// extracted by mini-css-extract-plugin
module.exports = {"atm_1nydj7r_1kiau1z":"atm_1nydj7r_1kiau1z","toggle-switch":"toggle-switch","atm_178sxfw_1ui8esr":"atm_178sxfw_1ui8esr","atm_k4_1piyxwk":"atm_k4_1piyxwk"};